export var getRandomColor = function () {
    var colors = [
        '#6ABC02',
        '#1693ED',
        '#695A93',
        '#DCAF3C',
        '#D9DC3C',
        '#2ecc71',
        '#3498db',
        '#9b59b6',
        '#e67e22',
        '#f1c40f',
    ];
    return colors[Math.floor(Math.random() * colors.length)];
};
